import "./footer.css"


// Social Icons

import facebookIcon from "../../media/images/facebookIcon.webp";
import instagramIcon from "../../media/images/instagramIcon.webp";

const Footer = () => {
    return (
        <footer>
    
        <div>
            <h2 id="footerHead">Ice Cream Creations</h2>
        </div>

        <div className="footerSection">
        <div className="footerCol">
            <h3>Follow our journey:</h3>
            <label>
            <input type="email" name="email"placeholder="Write e-mail address"required/>
             </label>
             <input type='submit' id="footerButton"></input>
        </div>
        <div className="footerCol">
            <h3>
            Check us out on social media!
            </h3>
        
            <a className="footerIcon" href="https://www.facebook.com/icecreamcreationsnj" 
            target={"blank"}>
                <img src={facebookIcon} aria-hidden='true' alt="Link to Facebook account" height={50} width={50}/>
            </a>
           
            <a className="footerIcon" href="https://www.instagram.com/icecreamcreationsnj" target={"blank"}> 
            <img src={instagramIcon} aria-hidden='true' alt="Link to Instagram account" height={50} width={50}/>
            </a>

        </div>

        <div className="footerCol">
        <h3>Get in touch with us:</h3>
        <a href="tel:+17321112222" className="footerText">732-111-2222</a>
        </div>


        

        </div>
        
        <div className="footerTerms"> 
        <a href="*">Terms of Use</a>
        <a href="*">Privacy Policy </a> 
        </div>
     
        </footer>
    )
}

export default Footer

